import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	"aria-hidden": "true",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 14 14",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
	})
});
export default SvgClose;
